import { Component, HostBinding, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { CustomToastersService } from 'src/app/shared/services';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
import { mergeMap } from 'rxjs/operators';
import { ProfileService } from '@app/api/api-services/profile.service';
import { AuthService } from '@app/api/api-services/auth.service';

@Component({
  templateUrl: './change-initial-password-modal.component.html',
  styleUrls: ['./change-initial-password-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChangeInitialPasswordModalComponent implements OnInit {
  @HostBinding('class')
  public modalType = 'grey fixed-height';

  public form: UntypedFormGroup;
  public pending: boolean;

  public readonly formKeys = {
    Password: 'Password',
    ConfirmPassword: 'ConfirmPassword',
    CurrentPassword: 'CurrentPassword'
  };

  private readonly subscriptions = new Array<Subscription>();

  constructor(
    private readonly bsModalRef: BsModalRef,
    private readonly customToastersService: CustomToastersService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly profileService: ProfileService,
    private readonly authService: AuthService
  ) {}

  public ngOnInit(): void {
    this.buildForm();
  }

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.pending = true;
    this.customToastersService.waitSave();

    const subscription = this.profileService
      .changeInitialPassword(this.form.value)
      .pipe(mergeMap(() => this.authService.requestRefreshAccToken()))
      .subscribe(
        () => {
          this.authService.changeInitialPasswordModalRef = null;
          this.customToastersService.completeSave();
          this.bsModalRef.hide();
        },
        () => {
          this.pending = false;
        }
      );

    this.subscriptions.push(subscription);
  }

  private buildForm(): void {
    this.form = this.formBuilder.group({
      [this.formKeys.Password]: ['', [Validators.required, CustomValidators.isInvalidPassword]],
      [this.formKeys.ConfirmPassword]: ['', [Validators.required, CustomValidators.isNotConfirmedPassword]],
      [this.formKeys.CurrentPassword]: ['', Validators.required]
    });

    this.subscriptions.push(
      this.form.get(this.formKeys.Password).valueChanges.subscribe(() => {
        this.form.get(this.formKeys.ConfirmPassword).updateValueAndValidity();
      })
    );

    this.subscriptions.push(
      this.form.get(this.formKeys.ConfirmPassword).valueChanges.subscribe(() => {
        this.form.get(this.formKeys.Password).updateValueAndValidity();
      })
    );
  }
}
